import React, { ReactElement } from 'react';

import { ReactComponent as NoNft } from '../../assets/svg/empty-states/no-nft.svg';

export const ImageTypes = {
  NONFTS: 'NO_NFTS',
};

interface EmptyStateProps {
  type: typeof ImageTypes.NONFTS;
  message: string;
  caption?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ type, message, caption }) => {
  let image: ReactElement | null;
  switch (type) {
    case ImageTypes.NONFTS:
      image = <NoNft />;
      break;
    default:
      image = null;
  }

  return (
    <div className="empty-state center">
      <div>{image}</div>
      <h2>{message}</h2>
      <p>{caption}</p>
    </div>
  );
};
